module.exports = __webpack_public_path__ + "img/speaker-icon.efea02ae.svg";